export enum GtmEvent {
  Custom = 'customEvent',
  ContactUsStart = 'contactus_start',
  ContactUsSubmit = 'contactus_submit',
}
